var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.fullPath.includes('/public/'))?_c('ComponentResolverPublic'):_c('App')
}
var staticRenderFns = []

export { render, staticRenderFns }